import { LiveEventEvolutionEntry } from '../../../live-events/types/LiveEventCollection'

/**
 * The evolution entry of a blueprint's newest event instance, which is the event the
 * "Open in Live Event Tracker" link opens the Event dialog on. The endpoint returns the
 * instances oldest first, so the newest is chosen by `start` rather than by position.
 * Evolution entries carry no end date, so equal starts fall back to the greater event id.
 */
export const latestEvolutionEntry = (evolution: LiveEventEvolutionEntry[] | undefined): LiveEventEvolutionEntry | undefined =>
  (evolution ?? []).reduce<LiveEventEvolutionEntry | undefined>((latest, entry) => {
    if (!entry.eventId) return latest
    if (!latest) return entry
    const startDiff = (entry.start ?? 0) - (latest.start ?? 0)
    if (startDiff !== 0) return startDiff > 0 ? entry : latest
    return entry.eventId > latest.eventId ? entry : latest
  }, undefined)
